import { apiClient } from './apiClient';

const getSubscriptionsList = async (payload) => {
  return await apiClient.get('/subscription/products', payload);
};

export const stripeApi = {
  getSubscriptionsList
};
